<template>
  <v-footer
    id="footer"
    class="justify-center"
  >
    <span>&copy;{{ new Date().getFullYear() }} — <a href="https://plas.eu">PLAS</a></span>
    <span class="ml-3 footer-beta">BETA</span>
    <span v-if="latestVersion" class="ml-2 caption">
      <router-link :to="{ name: 'dashboard' }" class="footer-version">
        v{{ latestVersion }}
      </router-link>
    </span>
  </v-footer>
</template>

<script>
  import releases from '../../assets/releases.json';
  import { getLatestVersion } from '../../utils/version';

  export default {
    name: 'TheFooter',
    computed: {
      latestVersion() {
        return getLatestVersion(releases);
      },
    },
  };
</script>

<style scoped>
  .footer-version {
    color: #7a8ca5 !important;
    text-decoration: none;
  }
  .footer-version:hover {
    color: #ffffff !important;
  }
  .footer-beta {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #ffffff;
    background-color: #ff6f00;
    border-radius: 4px;
    padding: 2px 8px;
  }
</style>
